<i18n src="./../../i18n/offers_page.json"></i18n>

<template>
    <div v-if="this.$route.name === 'offer' || categories.includes(this.$route.params.category)">
        <div v-if="loaded" id="offers-page" class="container-fluid">
            <vue-headful
                    :title="content.pageTitle ? content.pageTitle : $t('pageTitle')"
                    :description="content.pageDescription ? content.pageDescription : $t('pageDescription')"
                    :url="pageUrl"/>

            <navigation-bar/>

            <div id="paralax-subpage-section" class="lazy jumbotron mt-page-nav-image" data-bg="/assets/mt-default-page-header.jpg">
                <div class="container">
                    <h1 class="display-1 mt-f-regular par-text-1" style="opacity: 0.5;" v-text="$t('header')"/>
                </div>
            </div>

            <div class="container-fluid mt-subpage-section m-0 p-0">
                <div class="container-fluid m-0 p-0">
                    <div class="lazy container-fluid">

                        <div class="container">
                            <div class="content-container p-lg-3 pt-5">
                                <div class="container mt-offer-category">
                                    <div class="row no-gutters">
                                        <div class="col-lg-3 mt-offer-category-col mb-3">
                                            <h3 v-text="$t('leftMenu.title')"/>
                                            <router-link :to="{name: 'offerCategory', params: {category: categoryToilets}}">
                                                <div class="row no-gutters mt-offer-category-item">
                                                    <div class="col-3"><img class="lazy" data-src="/assets/mt-offer-thumbnail-toilet-b.png" :alt="categoryToilets"></div>
                                                    <div class="col-9 text-uppercase my-auto product-link-toalety" :class="{'mt-f-bold mt-c-blue-regular' : (this.$route.params.category === categoryToilets)}" v-text="$t('leftMenu.toilets')" />
                                                </div>
                                            </router-link>
                                            <hr/>
                                            <router-link :to="{name: 'offerCategory', params: {category: categoryContainers}}">
                                                <div class="row no-gutters mt-offer-category-item">
                                                    <div class="col-3"><img class="lazy" data-src="/assets/mt-offer-thumbnail-container-b.png" :alt="categoryContainers"></div>
                                                    <div class="col-9 text-uppercase my-auto product-link-kontenery" :class="{'mt-f-bold mt-c-blue-regular' : (this.$route.params.category === categoryContainers)}" v-text="$t('leftMenu.containers')" />
                                                </div>
                                            </router-link>
                                            <hr/>
                                            <router-link :to="{name: 'offerCategory', params: {category: categoryFences}}">
                                                <div class="row no-gutters mt-offer-category-item">
                                                    <div class="col-3"><img class="lazy" data-src="/assets/mt-offer-thumbnail-fance-b.png" :alt="categoryFences"></div>
                                                    <div class="col-9 text-uppercase my-auto product-link-ogrodzenia" :class="{'mt-f-bold mt-c-blue-regular' : (this.$route.params.category === categoryFences)}" v-text="$t('leftMenu.fancies')" />
                                                </div>
                                            </router-link>
                                            <hr/>
                                            <router-link :to="{name: 'offerCategory', params: {category: categoryOthers}}">
                                                <div class="row no-gutters mt-offer-category-item">
                                                    <div class="col-3"><img class="lazy" data-src="/assets/mt-offer-thumbnail-rubbish-b.png" :alt="categoryOthers"></div>
                                                    <div class="col-9 text-uppercase my-auto product-link-inne" :class="{'mt-f-bold mt-c-blue-regular' : (this.$route.params.category === categoryOthers)}" v-text="$t('leftMenu.others')" />
                                                </div>
                                            </router-link>
                                            <hr/>
                                            <router-link :to="{name: 'service'}">
                                                <div class="row no-gutters mt-offer-category-item">
                                                    <div class="col-3"><img class="lazy" data-src="/assets/mt-offer-thumbnail-service-b.png" :alt="categoryService"></div>
                                                    <div class="col-9 text-uppercase my-auto product-link-serwis" :class="{'mt-f-bold mt-c-blue-regular' : (this.$route.params.category === categoryService)}" v-text="$t('leftMenu.service')" />
                                                </div>
                                            </router-link>
                                            <hr/>
                                        </div>
                                        <div class="col-lg-9">

                                            <product-item v-for="item in content.products"
                                                          :key="item.id"
                                                          :item-data="item"
                                                          :configuration="content.configuration"/>

                                            <div v-if="categories.includes(this.$route.params.category)" class="pb-3 text-justify mt-offer-category-desc" v-html="content.description"/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <main-footer/>

                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <div v-else>
        <page-not-found/>
    </div>
</template>

<script>
    import NavigationBar from "@/components/commons/NavigationBar";
    import axios from "axios";
    import {Const} from "@/main";
    import MainFooter from "@/components/commons/MainFooter";
    import ProductItem from "@/components/offers/ProductItem";
    import PageNotFound from "@/components/commons/PageNotFound";
    import LazyLoad from "vanilla-lazyload";

    var lazyLoadInstance = new LazyLoad({
        elements_selector: ".lazy"
    });

    export default {
        name: "OffersPage",
        components: {PageNotFound, ProductItem, MainFooter, NavigationBar},
        data () {
            return {
                locale: this.$i18n.locale,
                categoryToilets: Const.CATEGORY_TOILETS,
                categoryContainers: Const.CATEGORY_CONTAINERS,
                categoryFences: Const.CATEGORY_FANCIES,
                categoryOthers: Const.CATEGORY_OTHERS,
                categoryService: Const.CATEGORY_SERVICE,
                categories: [Const.CATEGORY_TOILETS, Const.CATEGORY_CONTAINERS, Const.CATEGORY_FANCIES, Const.CATEGORY_OTHERS],
                content: {},
                loaded: false,
                pageUrl: Const.HOST + this.$route.path
            }
        },
        mounted() {
            if (this.$route.name === 'offer') {
                axios.get(`${Const.API_HOST}/${this.locale}/content/offer`)
                    .then(function (response) {
                        return response.data;
                    }).catch(function (error) {
                    // eslint-disable-next-line no-console
                    console.log(error);
                }).then(body => {
                    this.content = body
                    this.loaded = true

                    this.$nextTick(() => {
                        lazyLoadInstance.update()
                    })
                });
            } else if (this.categories.includes(this.$route.params.category)) {
                axios.get(`${Const.API_HOST}/${this.locale}/content/offer/${this.$route.params.category}`)
                    .then(function (response) {
                        return response.data;
                    }).catch(function (error) {
                    // eslint-disable-next-line no-console
                    console.log(error);
                }).then(body => {
                    this.content = body
                    this.loaded = true

                    this.$nextTick(() => {
                        lazyLoadInstance.update()
                    })
                });
            } else {
                this.loaded = true

                this.$nextTick(() => {
                    lazyLoadInstance.update()
                })
            }

        }
    }
</script>

<style scoped>
    #paralax-subpage-section {
        height: 200px;
    }

    .mt-offer-category .mt-offer-category-item img {
        width: 70%;
    }

    .mt-offer-category hr {
        margin-top: 0;
        margin-bottom: 0;
        margin-right: 50px;
    }

    .mt-offer-category li {
        padding-top: 1rem;
    }

    .mt-offer-category-col a {
        color: rgba(0,0,0,.5);
        text-decoration: none;
    }

    .mt-offer-category-col a:hover {
        color: #295d92;
    }
</style>